import { useState, useRef, useEffect } from 'react';
import { useSearchStore } from '../../store/store';
import { getSelectedAgentIds } from '../../common/components/table/agGrid/crossViewSelection';

export const useFloatingActionBar = (externalGridRef, onDownload) => {
    const internalGridRef = useRef();
    const gridRef = externalGridRef || internalGridRef;
    const [showAddToListModal, setShowAddToListModal] = useState(false);
    const [showNewListModal, setShowNewListModal] = useState(false);

    const {
        selectedCount,
        clearSelectedAgentIds,
    } = useSearchStore(state => ({
        selectedCount: getSelectedAgentIds(state)?.length ?? 0,
        clearSelectedAgentIds: state.clearSelectedAgentIds,
    }));

    const onDownloadRef = useRef(onDownload);
    useEffect(() => {
        onDownloadRef.current = onDownload;
    }, [onDownload]);

    const handleDownloadClick = () => {
        const rows = gridRef?.current?.api?.getSelectedRows() ?? [];
        onDownloadRef.current?.(rows);
    };

    const handleDismiss = () => {
        gridRef?.current?.api?.deselectAll();
        clearSelectedAgentIds();
    };

    const resetSelection = () => {
        setShowAddToListModal(false);
        gridRef?.current?.api?.deselectAll();
        clearSelectedAgentIds();
    };

    return {
        gridRef,
        selectedCount,
        showNewListModal,
        showAddToListModal,
        setShowAddToListModal,
        setShowNewListModal,
        handleDownloadClick,
        handleDismiss,
        resetSelection,
    };
};
